







































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import DocReviewDialog from "../Dialogs/DocReviewDialog.vue";
import DocSignDialog from "../Dialogs/DocSignDialog.vue";
import { bus } from "../../main";
import QuestionarioDialog from "../Dialogs/QuestionarioDialog.vue";

@Component({
  components: {
    DocReviewDialog,
    DocSignDialog,
    QuestionarioDialog
  }
})
export default class TirociniEstiviDoc extends Vue {
  @Prop() idRichiesta!: number;
  @Prop() activityType!: string;
  @Prop() soggetto!: string; //entità che visualizza l'elenco documenti
  @Prop() statoAttivita!: number;
  @Prop() tipoQuestionario!: string;

  private convenzione: any;
  private progettoOrientamento: any;
  private attestatoFinale: any;
  private questionario: any;
  private questionario2: any;
  private show: boolean;
  private docType: string;

  private wrapperIdRichiesta: any;
  private wrapperDialogTitle: any;

  private loadingConvenzioneReview: boolean;
  private loadingProgettoOrientamentoReview: boolean;
  private loadingAttestatoFinaleReview: boolean;
  private loadingQuestionarioReview: boolean;

  constructor() {
    super();
    this.convenzione = {};
    this.progettoOrientamento = {};
    this.attestatoFinale = {};
    this.questionario = {};
    this.questionario2 = {};
    this.show = true;
    this.docType = "";

    this.wrapperIdRichiesta = {
      idRichiesta: this.idRichiesta
    };
    this.wrapperDialogTitle = {
      title: "QUESTIONARIO TIROCINIO ESTIVO"
    };

    this.loadingConvenzioneReview = false;
    this.loadingProgettoOrientamentoReview = false;
    this.loadingAttestatoFinaleReview = false;
    this.loadingQuestionarioReview = false;
  }

  openConvenzione() {
    this.loadingConvenzioneReview = true;
    this.docType = "convenzione";
    bus.$emit("openDocConvenzioneReview", this.convenzione);
  }

  openProgettoOrientamento() {
    this.loadingProgettoOrientamentoReview = true;
    this.docType = "progettoOrientamento";
    bus.$emit("openDocProgettoOrientamentoReview", this.progettoOrientamento);
  }

  openAttestatoFinale() {
    this.loadingAttestatoFinaleReview = true;
    this.docType = "attestatoFinale";
    bus.$emit("openDocAttestatoFinaleReview", this.attestatoFinale);
  }

  openQuestionario(tipoQuestionario: string) {
    if (this.soggetto === "istituto") {
      if (tipoQuestionario === "questionarioTirocinante") {
        this.loadingQuestionarioReview = true;
        this.docType = "questionarioTirocinante";
        bus.$emit("openDocQuestionarioReview", this.questionario);
      } else if (tipoQuestionario === "questionarioAzienda") {
        this.loadingQuestionarioReview = true;
        this.docType = "questionarioAzienda";
        bus.$emit("openDocQuestionarioReview", this.questionario2);
      }
    } else if (this.soggetto === "azienda") {
      this.loadingQuestionarioReview = true;
      this.docType = "questionarioAzienda";
      bus.$emit("openDocQuestionarioReview", this.questionario);
    } else if (this.soggetto === "allievo") {
      this.loadingQuestionarioReview = true;
      this.docType = "questionarioTirocinante";
      bus.$emit("openDocQuestionarioReview", this.questionario);
    } else if (this.soggetto === "tutorAziendale") {
      this.loadingQuestionarioReview = true;
      this.docType = "questionarioAzienda";
      bus.$emit("openDocQuestionarioReview", this.questionario);
    }

    // else {
    //   this.loadingQuestionarioReview = true;
    //   this.docType = "questionario";
    //   bus.$emit("openDocQuestionarioReview", this.questionario);
    // }
  }

  loadConvenzione() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType
    };
    data
      .dispatchConvenzioneAttivita(this["$store"], payload)
      .then(result => {
        this.convenzione = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadProgettoOrientamento() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType
    };
    data
      .dispatchProgettoOrientamento(this["$store"], payload)
      .then(resp => {
        this.progettoOrientamento = resp;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadAttestatoFinale() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType
    };
    data
      .dispatchAttestatoFinaleInfo(this["$store"], payload)
      .then(resp => {
        this.attestatoFinale = resp;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadQuestionario() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType,
      tipoQuestionario: this.tipoQuestionario
    };
    if (this.tipoQuestionario === "questionariSoddisfacimento") {
      payload.tipoQuestionario = "questionarioTirocinante";
      data
        .dispatchRisposteQuestionario(this["$store"], payload)
        .then(result => {
          this.questionario = result;
          payload.tipoQuestionario = "questionarioAzienda";
          data
            .dispatchRisposteQuestionario(this["$store"], payload)
            .then(result2 => {
              this.questionario2 = result2;
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      data
        .dispatchRisposteQuestionario(this["$store"], payload)
        .then(result => {
          this.questionario = result;
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    }
  }

  created() {
    if (this.soggetto === "allievo") {
      this.loadProgettoOrientamento();
      if (this.statoAttivita === 4) {
        this.loadAttestatoFinale();
        this.loadQuestionario();
      }
    } else if (this.soggetto === "tutorAziendale") {
      if (this.statoAttivita === 4) {
        this.loadAttestatoFinale();
        this.loadQuestionario();
      }
    } else {
      if (this.statoAttivita === 4) {
        this.loadAttestatoFinale();
        this.loadQuestionario();
      }
      this.loadConvenzione();
      this.loadProgettoOrientamento();
    }

    bus.$on("loadConvenzione", () => {
      this.loadingConvenzioneReview = false;
      this.loadConvenzione();
    });

    bus.$on("loadProgettoOrientamento", () => {
      this.loadingProgettoOrientamentoReview = false;
      this.loadProgettoOrientamento();
    });

    bus.$on("loadAttestatoFinale", () => {
      this.loadingAttestatoFinaleReview = false;
      this.loadAttestatoFinale();
    });

    bus.$on("loadQuestionario", () => {
      this.loadingQuestionarioReview = false;
      this.loadQuestionario();
    });

    bus.$on("closeDocReview", async () => {
      this.loadingConvenzioneReview = false;
      this.loadingProgettoOrientamentoReview = false;
      this.loadingAttestatoFinaleReview = false;
      this.loadingQuestionarioReview = false;

      this.show = false;
      await this.$nextTick();
      this.show = true;
    });

    bus.$on("refreshDocs", () => {
      this.loadConvenzione();
      this.loadProgettoOrientamento();
      if (this.statoAttivita === 4) {
        this.loadAttestatoFinale();
        this.loadQuestionario();
      }
    });
  }
}
